import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import ErrorIcon from '@mui/icons-material/Error'
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded'
import FileSaver from 'file-saver'
import { toast } from 'react-toastify'
import { downloadreport } from '../services/fetchreport'
import { CircularProgress, Tooltip } from '@mui/material'
import '../Customportal.scss'
 
interface Props {
  index?: number
  report?: any[]
  em?: string
  e_id?: string
  isInternal?: boolean
}

export default function DownloadComponent({ index = 1, report = [], em, e_id,isInternal }) {
  const userData = useSelector((state: any) => state.reducers.userInfo)
    let internalUser = false
    if ((userData[0].userType.indexOf('Internal') > -1) || (userData[0].userType.indexOf('er.internal') > -1) || (userData[0].userType.indexOf('internal') > -1)) {
      internalUser = true
    }
  // const DownloadComponent: React.FC<Props> = ({ index = 1, report = [], em, e_id,isInternal }) => {
  const [isloading, setLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isHighlighted, setIsHighlighted] = useState(false)
 
  const handleDownload = async () => {
    setIsError(false)
    setLoading(true)
    if(internalUser) {
      const downloaded = await downloadreport(report[5], report[0], `${report[2]}.xlsx`, em, e_id)
      setLoading(false)
      if (downloaded && !(downloaded as any).error) {
        FileSaver.saveAs(downloaded as Blob, `${report[2]}.${(downloaded as Blob).type.substring(12)}`)
      }else {
        setIsError(true)
        toast.error((downloaded as any)?.message || 'Something went wrong while downloading the report.', {
          position: 'top-right',
          autoClose: 2250
        })
      }
    }else {
      const downloaded = await downloadreport(report[4], report[0], `${report[1]}.xlsx`, em, e_id)
      setLoading(false)
      if(downloaded && !(downloaded as any).error) {
        FileSaver.saveAs(downloaded as Blob, `${report[1]}.${(downloaded as Blob).type.substring(12)}`)
      } else {
        setLoading(false)
        setIsError(true)
        toast.error((downloaded as any)?.message || 'Something went wrong while downloading the report.', {
          position: 'top-right',
          autoClose: 2250
        })
      }
    }
  }
 
  const changeColor = (value: boolean) => {
    setIsHighlighted(value)
  }
 
  return (
    <>
      {isloading ? (
        <CircularProgress />
      ) : isError ? (
        <>
          <ErrorIcon /> <button type='button' className='metlife-link-a' onClick={handleDownload}>Retry?</button>
        </>
      ) : (
        <Tooltip title='Click To Download Report' arrow>
          <DownloadRoundedIcon
            onMouseOver={() => changeColor(true)}
            onMouseLeave={() => changeColor(false)}
            className={'download-link'}
            data-index={index}
            onClick={handleDownload}
            style={{ color: isHighlighted ? '#333333' : '#007abc' }}
          />
        </Tooltip>
      )}
    </>
  )
}
